import dayjs from 'dayjs';
import { Coordinates } from '../coordinates.model';
import { INommable } from '../nommable.interface';
import { UserEvent } from './user-event.model';

export class InfoRondeEvent extends UserEvent {
  public static NAME = 'INFO_RONDE';

  constructor(
    public texte: string | undefined,
    public photos: string[],
    instant?: dayjs.Dayjs,
    coordinates?: Coordinates,
    public siteId?: string,
    public tourneeId?: string,
    public site?: INommable
  ) {
    super(InfoRondeEvent.NAME, instant, coordinates);
  }

  public static hydrate(obj: InfoRondeEvent): InfoRondeEvent {
    return new InfoRondeEvent(obj.texte, obj.photos, obj.instant, obj.coordinates, obj.siteId, obj.tourneeId, obj.site);
  }
}
